var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCube = function SvgCube(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "cube_svg__a",
    x: 3,
    y: 0,
    width: 44,
    height: 50,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 1.732a6 6 0 0 1 6 0l15.651 9.036a6 6 0 0 1 3 5.196v18.072a6 6 0 0 1-3 5.196L28 48.268a6 6 0 0 1-6 0L6.349 39.232a6 6 0 0 1-3-5.196V15.964a6 6 0 0 1 3-5.196L22 1.732z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 20.839V52L5.206 41.585A6 6 0 0 1 2 36.275V10l23 10.839Z",
    fill: "#F6936A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 20.839V52l19.794-10.415A6 6 0 0 0 48 36.275V10L25 20.839Z",
    fill: "#F26740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25-1 23 13.158L25 24 2 12.158 25-1Z",
    fill: "#FFAC89"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cube_svg__b",
    x: -6,
    y: -9,
    width: 62,
    height: 33,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25-9 55.36 8.368 25 24-5.36 8.368 25-9z",
    fill: "#FFAC89"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cube_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 22.68,
    r: 29.04,
    fill: "url(#cube_svg__c)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cube_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 29.04 -29.04 0 25 22.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8AD",
    stopOpacity: 0,
    offset: 1
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCube);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9Im5vbmUiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDUwIDUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxtYXNrIGlkPSJvcmFuZ2VjdWJlYiIgeD0iMyIgeT0iMCIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjUwIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJtMjIgMS43MzJjMS44NTY0LTEuMDcxOCA0LjE0MzYtMS4wNzE4IDYgMGwxNS42NTEgOS4wMzU4YzEuODU2NCAxLjA3MTggMyAzLjA1MjYgMyA1LjE5NjJ2MTguMDcyYzAgMi4xNDM2LTEuMTQzNiA0LjEyNDQtMyA1LjE5NjJsLTE1LjY1MSA5LjAzNThjLTEuODU2NCAxLjA3MTgtNC4xNDM2IDEuMDcxOC02IDBsLTE1LjY1MS05LjAzNThjLTEuODU2NC0xLjA3MTgtMy0zLjA1MjYtMy01LjE5NjJ2LTE4LjA3MmMwLTIuMTQzNiAxLjE0MzYtNC4xMjQ0IDMtNS4xOTYybDE1LjY1MS05LjAzNTh6IiBmaWxsPSIjQzRDNEM0Ii8+PC9tYXNrPjxnIG1hc2s9InVybCgjb3JhbmdlY3ViZWIpIj48cGF0aCBkPSJNMjUgMjAuODM4N1Y1Mkw1LjIwNjE3IDQxLjU4NTNDMy4yMzQ1IDQwLjU0NzggMiAzOC41MDM0IDIgMzYuMjc1NFYxMEwyNSAyMC44Mzg3WiIgZmlsbD0iI0Y2OTM2QSIvPjxwYXRoIGQ9Ik0yNSAyMC44Mzg3VjUyTDQ0Ljc5MzggNDEuNTg1M0M0Ni43NjU1IDQwLjU0NzggNDggMzguNTAzNCA0OCAzNi4yNzU0VjEwTDI1IDIwLjgzODdaIiBmaWxsPSIjRjI2NzQwIi8+PHBhdGggZD0iTTI1IC0xTDQ4IDEyLjE1NzlMMjUgMjRMMiAxMi4xNTc5TDI1IC0xWiIgZmlsbD0iI0ZGQUM4OSIvPjxtYXNrIGlkPSJvcmFuZ2VjdWJlYyIgeD0iLTYiIHk9Ii05IiB3aWR0aD0iNjIiIGhlaWdodD0iMzMiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiPjxwYXRoIGQ9Im0yNS05IDMwLjM2IDE3LjM2OC0zMC4zNiAxNS42MzItMzAuMzYtMTUuNjMyIDMwLjM2LTE3LjM2OHoiIGZpbGw9IiNGRkFDODkiLz48L21hc2s+PGcgbWFzaz0idXJsKCNvcmFuZ2VjdWJlYykiPjxjaXJjbGUgY3g9IjI1IiBjeT0iMjIuNjgiIHI9IjI5LjA0IiBmaWxsPSJ1cmwoI29yYW5nZWN1YmVhKSIvPjwvZz48L2c+PGRlZnM+PHJhZGlhbEdyYWRpZW50IGlkPSJvcmFuZ2VjdWJlYSIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDI1IDIyLjY4KSByb3RhdGUoOTApIHNjYWxlKDI5LjA0KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiNGRkYwQzgiIG9mZnNldD0iMCIvPjxzdG9wIHN0b3AtY29sb3I9IiNGRkU4QUQiIHN0b3Atb3BhY2l0eT0iMCIgb2Zmc2V0PSIxIi8+PC9yYWRpYWxHcmFkaWVudD48L2RlZnM+PC9zdmc+Cg==";